module.exports = __webpack_public_path__ + "img/aboutus.f401321b.jpg";